import { ComponentPropsWithoutRef } from 'react';
import classNames from 'classnames';

export const TextButton = ({
  className,
  children,
  disabled,
  onClick,
}: Pick<
  ComponentPropsWithoutRef<'button'>,
  'className' | 'children' | 'disabled' | 'onClick'
>) => (
  <button
    type="button"
    className={classNames(
      'underline text-teal-400 rounded-md',
      'focus:outline-none focus:ring focus:ring-offset-2',
      disabled ? 'cursor-default text-opacity-50' : 'hover:text-teal-600',
      className
    )}
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </button>
);
